import { render, staticRenderFns } from "./JoinEventButton.vue?vue&type=template&id=642c4168&scoped=true&"
import script from "./JoinEventButton.vue?vue&type=script&lang=js&"
export * from "./JoinEventButton.vue?vue&type=script&lang=js&"
import style0 from "./JoinEventButton.vue?vue&type=style&index=0&id=642c4168&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c4168",
  null
  
)

export default component.exports